'use strict';

module.exports = function() {
    this.seenEndpoint = null;
    this.isMenuOpen = false;

    this.attributes({
        key: null,
        detachedDropdown: null,
        offCanvasMenuItem: null,
        content: null,
        link: null,
        countContainer: null,
        count: null,
    });

    this.after('initialize', function() {
        this.on(document, 'brandContainer.data.asyncMenuData', this.updateMenu);

        this.on('click', {
           link: this.handleMenuOpen,
        });

        // Fired by detachedDropdown
        this.on('closed', {
            detachedDropdown: this.handleMenuClose,
        });
    });

    this.handleMenuOpen = function() {
        this.isMenuOpen = true;
        this.trigger('brandContainer.ui.asyncMenuSeen', {
            key: this.attr.key,
            endpoint: this.seenEndpoint
        });
    };

    this.handleMenuClose = function() {
        if (this.isMenuOpen) {
            this.updateCount(0);
            this.isMenuOpen = false;
        }
    };

    this.updateMenu = function(e, data) {
        if (this.attr.key !== data.key) {
            return;
        }

        this.select('content').html(data.content);
        this.trigger('uiNeedsTimeUpdate');
        this.updateCount(data.unseenCount);
        this.seenEndpoint = data.seenEndpoint;
    };

    this.updateCount = function(count) {
        var count = Number(count);

        if (count > 0) {
            this.select('count').html(count);
            this.select('countContainer').removeAttr('data-hidden');
            this.select('offCanvasMenuItem').addClass('menu__item__action--has-pill');
        } else {
            this.select('countContainer').fadeOut(200, function () {
                this.select('count').html(count);
                this.select('countContainer').attr('data-hidden', true);
                this.select('offCanvasMenuItem').removeClass('menu__item__action--has-pill');
            }.bind(this));
        }
    }
};



/** WEBPACK FOOTER **
 ** ./~/@99designs/brand-container/lib/ui/mixins/async-menu.js
 **/